import React from 'react';
import { useAuth } from '../../context/AuthContext';
import styles from './HrmsPage.module.css';

const HRMS_WEB_URL = 'https://boosthrm.in/Dash.aspx';
const HRMS_CLIENT_ID = 'dpc';

const HrmsPage = () => {
  const { user } = useAuth();
  const employeeCode = user?.employeeCode || '—';

  return (
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <div className={styles.pageTitle}>HRMS</div>
      </div>

      <div className={styles.card}>
        <div className={styles.sectionTitle}>Web Login</div>
        <p className={styles.text}>
          Use the link below to mark your daily attendance and access HRMS from a browser.
        </p>
        <a
          href={HRMS_WEB_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkBtn}
        >
          Open HRMS Web →
        </a>
      </div>

      <div className={styles.card}>
        <div className={styles.sectionTitle}>Mobile App</div>
        <p className={styles.text}>
          Download the <strong>Nitso</strong> app from the Play Store for daily attendance
          (in / out) from your phone.
        </p>
      </div>

      <div className={styles.card}>
        <div className={styles.sectionTitle}>Your Login Details</div>
        <div className={styles.credsGrid}>
          <div className={styles.credLabel}>Client ID</div>
          <div className={styles.credValue}>{HRMS_CLIENT_ID}</div>

          <div className={styles.credLabel}>User Login</div>
          <div className={styles.credValue}>{employeeCode}</div>

          <div className={styles.credLabel}>Password</div>
          <div className={styles.credValue}>{employeeCode} (same as your employee code)</div>
        </div>
      </div>
    </div>
  );
};

export default HrmsPage;
